import { UP2RENT_APP_URL } from '@rentguru/commons-utils';

import { getCurrentEnv } from 'src/utils/envUtils';

const CONTACTSYNCURL = import.meta.env.VITE_CONTACTSYNCURL_URL;
const MICROSOFT_CONNECT_URL = import.meta.env.VITE_MICROSOFT_CONNECT_URL;
const GOOGLE_CONNECT_URL = import.meta.env.VITE_MICROSOFT_CONNECT_URL;

const BASE_URL = `https://cloudintegrations.api.${getCurrentEnv()}.${UP2RENT_APP_URL}`;

export const getContactSyncUrl = (): string => CONTACTSYNCURL ?? `${BASE_URL}/syncContacts`;

export const getMicrosoftConnectUrl = (): string => MICROSOFT_CONNECT_URL ?? `${BASE_URL}/microsoftConnect`;

export const getGoogleConnectUrl = (): string => GOOGLE_CONNECT_URL ?? `${BASE_URL}/googleConnect`;
